import request from "./client";

export type TenancyRecord = {
  id: number;
  tenant_id: number;
  room_id: number;
  tenancy_start: string;
  payment_date: string;
  tenancy_end?: string | null;
  monthly_rent?: number | null;
  deposit_amount?: number | null;
  status: string;
  notes?: string | null;
  created_at?: string;
};

export async function getTenancies() {
  return request<TenancyRecord[]>("/api/tenancies");
}

export async function createTenancy(payload: Record<string, unknown>) {
  return request<TenancyRecord>("/api/tenancies", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateTenancy(
  id: number,
  payload: Record<string, unknown>,
) {
  return request<TenancyRecord>(`/api/tenancies/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function deleteTenancy(id: number) {
  return request<{ success: boolean }>(`/api/tenancies/${id}`, {
    method: "DELETE",
  });
}
